<template>
    <header v-bind:class="$style.container">
        <div v-bind:class="$style.navigation">
            <MainHeaderNavigationBar />
        </div>
        <div
            v-if="isSearchExpanded"
            v-bind:class="$style.searchBar"
        >
            <MainHeaderSearchBar />
        </div>
    </header>
</template>

<script>
    import MainHeaderNavigationBar from '@components/MainHeaderNavigationBar';
    import MainHeaderSearchBar from '@components/MainHeaderSearchBar';
    import MediaQueries from '@mixins/MediaQueries';

    export default {
        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            MainHeaderNavigationBar,
            MainHeaderSearchBar,
        },

        /**
         * Mixins are a flexible way to distribute reusable functionalities for Vue components.
         * A mixin object can contain any component options. When a component uses a mixin,
         * all options in the mixin will be “mixed” into the component’s own options.
         *
         * @link https://vuejs.org/v2/guide/mixins.html
         */
        mixins: [
            MediaQueries,
        ],

        /**
         * Cached computed methods for complex logic on the view layer.
         *
         * @link https://vuejs.org/v2/guide/computed.html
         *
         * @type Object The computed functions
         */
        computed: {
            isSearchExpanded () {
                return this.$store.getters['search/isSearchExpanded'];
            },
        },
    };
</script>

<style lang="scss" module>
    @import '@design';

    .navigation {
        @apply bg-gray-800 px-10 py-4;
        max-height: 8rem;

        > div {
            @apply flex items-center justify-between;
        }
    }

    .searchBar {
        @apply bg-gray-400;
        min-height: 6.45rem;

        > div {
            @apply flex;
            min-height: 6.45rem;
        }
    }
</style>
